<template>
  <span>
    <b-modal @hidden="resetModal" ref="modal-container" v-model="modalShow" size="xl" :noCloseOnBackdrop="true" static lazy hide-footer data-bs-backdrop="static">
      <template #modal-title="">
        Import
      </template>
      <div id="loading-modal">
        <div class="row">
          <div class="p-0 text-center" :class="getClassForCol(header)" v-for="header in headers" :key="header">
            <small><strong>{{ header }}</strong></small>
          </div>
        </div>
        <div v-for="(row) in importData" :key="row.id">
          <div class="row">
            <div class="p-0" :class="getClassForCol(header)" v-for="header in headers" :key="header">
              <input type="text" class="form-control form-control-sm rounded-0"
                     :class="{'border border-danger': isSubmitted && hasErrors(row.id), 'border border-success': isSubmitted && !hasErrors(row.id)}"
                     :readonly="isSubmitted && !hasErrors(row.id)"
                     v-model="row[header]"
              >
            </div>
          </div>
          <div class="row text-center" v-if="isSubmitted && hasErrors(row.id)">
            <small v-for="(error,index) in getErrors(row.id)" :key="index" class="text-danger col pb-2">{{ error.message }}</small>
          </div>
        </div>

      </div>

      <b-button v-if="isSubmitted && this.errors.length > 0" class="mt-2 float-right" variant="warning" @click="handleSubmit" :disabled="isLoading">Import only failed</b-button>
      <b-button v-else class="mt-2 float-right" variant="primary" @click="handleSubmit" :disabled="isLoading">Import</b-button>

    </b-modal>
  </span>
</template>
<style>
.col-6p {
  flex: 0 0 6%;
  max-width: 6% !important;
}
</style>
<script>
import DatePicker from 'vue2-datepicker';

const headers = ["secret", "table_id", "player_id", "type", "currency", "start_date", "end_date", "count", "stake", "value"];

export default {
  components: {
    DatePicker,
  },
  data() {
    return {
      headers,
      errors: [],
      modalShow: false,
      isLoading: false,
      importData: [],
      isSubmitted: false
    }
  },
  props: {
  },
  methods: {
    resetModal() {
    },
    hideModal() {
      this.modalShow = false
      this.$refs['modal-container'].hide();
    },
    toggle() {
      this.modalShow = !this.modalShow;
    },
    showModal(importData) {
      this.isSubmitted = false;
      this.errors = [];
      this.importData = importData;
      this.modalShow = true
      this.$refs['modal-container'].show();
    },
    getClassForCol(col) {
      if (["secret"].indexOf(col) >= 0) {
        return 'col';
      }

      if (["end_date", "start_date"].indexOf(col) >= 0) {
        return 'col-2';
      }
      return 'col col-6p';
    },
    hasErrors(rowId) {
      return this.getErrors(rowId).length > 0
    },
    getErrors(rowId) {
      return this.errors.filter((item) => item.id === rowId)
    },
    handleSubmit() {
      if (this.isLoading) {
        return;
      }

      let loadingInstance = this.$veLoading({
        target: document.querySelector("#loading-modal"),
        name: "wave",
      });

      loadingInstance.show();
      this.isLoading = true;

      this
        .$http({
          url: '/api/v1/wazdan-freespins/import',
          method: 'POST',
          data: this.filteredImportData,
          headers: {'Content-Type': 'application/json'},
        })
        .then((resp) => {
          this.isSubmitted = true;
          if (resp.data.errors.length > 0) {
            this.errors = resp.data.errors;
            this.$toastr.Add({
              type: "warning",
              msg: 'Import complete with errors, please review failed lines'
            });
          } else {
            this.$toastr.i('Import successful complete');
            this.hideModal();
          }
        })
        .catch((err) => {
          console.log(err);
          this.$toastr.e(JSON.stringify(err.response.data.message));
        })
        .finally(() => {
          this.isLoading = false;
          loadingInstance.close();
        });

    },
  },
  computed: {
    filteredImportData() {
      if (!this.isSubmitted) {
        return this.importData;
      }
      return this.importData.filter((item) => this.hasErrors(item.id))
    }
  },
  mounted() {
  },
}
</script>
